/**
 * The sort values the SRP understands. "match" (JobCrawls Plus, spec 6.9) re-orders an over-fetched
 * window of the best-ranked results by the visitor's match score; it is a sort, never a filter, and
 * every code path that does not know it treats it like "relevance".
 */
export type SrpSort = 'relevance' | 'date' | 'salary' | 'match';

export function isSrpSort(value: unknown): value is SrpSort {
  return value === 'relevance' || value === 'date' || value === 'salary' || value === 'match';
}
